$(function () {
  const $select2 = $('.js-select2');
  const $multiple = $select2.filter('[multiple]');
  const $select2Price = $select2.filter('.select2_price');

  $select2.select2({
    allowClear: true,
    width: '100%',
  })

  $select2.on('select2:selecting', function (e) {
    $(this).parent().addClass('select2-block_active');
  });

  $multiple.select2({
    allowClear: true,
    width: '100%',
    closeOnSelect: false
  }).each((_, select) => {
    const $select = $(select)
    multipleChangeCallback($select)
    replaceInputToDiv($select.next())
  })

  $multiple.on('change.select2', e => multipleChangeCallback($(e.currentTarget)));

  function chooseTemplate(name, amount) {
    return (`
      <li class="select2-selection__display">
        <div class="select2-selection__display-name">
          ${name}
        </div>
        <div class="select2-selection__display-amount">
          (${amount})
        </div>
      </li>
    `)
  }

  function replaceInputToDiv(select) {
    const element = select.find('.select2-search .select2-search__field');
    const placeholder = element.attr('placeholder');
    element.replaceWith(`<div class='select2-search__field'>${placeholder}</div>`);
  }

  function multipleChangeCallback(that) {
    const {
      placeholder
    } = that.data();
    const val = that.val();
    const select2 = that.next().find('.select2-selection.select2-selection--multiple');
    const selectRender = select2.find('.select2-selection__rendered');
    selectRender.find('.select2-selection__choice, .select2-selection__display').remove();

    if (!!val.length && !!val.join('')) {
      select2.addClass('is-selected');
      selectRender.append(chooseTemplate(placeholder, val.length));
      return
    }
    select2.removeClass('is-selected').closest('.select2-block').removeClass('select2-block_active').end().find('.select2-search__field').text(placeholder);
    that.val([]);
  }

  $.each($multiple, function () {
    $(this).data().select2.$dropdown.addClass('select2-dropdown_multiple');
  });

  $.each($select2Price, function () {
    $(this).data().select2.$dropdown.addClass('select2-dropdown_price');
  });
})